
export const authRoutes = [
  //Error
  //  { path: `${process.env.PUBLIC_URL}/pages/others/error400`, Component: <Error400/> }
];
